import { UserProjectDisplaySettingsApi } from "~/api/UserProjectDisplaySettings";

export function useUserProjectDisplaySettingsApi(): UserProjectDisplaySettingsApi {
  const userProjectDisplaySettingsApi = new UserProjectDisplaySettingsApi(useHttpClient());

  return userProjectDisplaySettingsApi;
}
